import React from "react";
import styled from "styled-components";
import { toShortMonthText } from "../../../utils/date";
import * as dateMath from 'date-arithmetic';
import { colors } from "../../colors/color";
import { TITLE_CELL_WIDTH_PX } from "./graphUtils";


type TimelineGraphMonthProps = {
    yearMonthStart: Date,
    rowWidthPx: number,
    months: number,
};
export function TimelineGraphMonthHeader (props: TimelineGraphMonthProps): JSX.Element
{
    const months:{current: boolean, text: string}[] = [];
    for (let i = 0; i < props.months; i++)
    {
        const yearMonth = dateMath.add(props.yearMonthStart, i, 'month');
        const now = new Date();
        const current = yearMonth.getFullYear() === now.getFullYear() && yearMonth.getMonth() === now.getMonth();
        months.push({ current, text: toShortMonthText(dateMath.add(props.yearMonthStart, i, 'month')) });
    }

    return (
        <HeaderWrapper>
            <HeaderTitleSpacer />
            {months.map((m) => 
                <GraphMonthHeader key={m.text}current={m.current}
                    style={{width: (props.rowWidthPx- TITLE_CELL_WIDTH_PX) /props.months}}>
                    
                    {m.text}

                </GraphMonthHeader>
            )}
        </HeaderWrapper>
    );
}


const border = '0px solid #000';

const HeaderWrapper = styled.div`
    display:flex; 
    justify-content:stretch;
`;

const HeaderTitleSpacer = styled.div`
    width: ${TITLE_CELL_WIDTH_PX}px;
    flex-shrink: 0;
`;

const GraphMonthHeader = styled.div<{current?:boolean}>`
    border-left:${border};
    border-top:${border};
    border-bottom:${border};
    flex-grow: 1;
    display:flex;
    justify-content: center;
    line-height: 20px;
    font-family: 'Noto Sans', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color:${props => props.current ? colors.text.highlighted : colors.text.light};
    ${props => props.current && `
        text-decoration: underline;
    `}
    text-transform: uppercase;

    :last-child
    {
        border-right:${border};
    }
`;